// follow the RFC-5322 -> https://datatracker.ietf.org/doc/html/rfc5322
export const EMAIL_REGEX_FORMAT = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

export const APPS = {
    SSO: 'sso',
    LASTA: 'lasta',
};

export const EMAIL_FIELD_NAME = "email"